<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue';
  import { DocumentModal } from '@/entities/Document';
  import { DocumentRevision, documentApi } from '@/entities/Document';
  import { HistoryRevisionList } from '@/features/Document';
  import { buildDocumentHistoryView } from '../model/document-history-view';

  const props = defineProps<{
    title: string;
    revision: DocumentRevision | null;
  }>();

  const emit = defineEmits<{
    close: [];
  }>();

  const revisions = ref<DocumentRevision[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const getRevisions = async () => {
    try {
      loading.value = true;
      error.value = null;
      const data = await documentApi.getDocumentHistory(props.revision?.documentId!);
      revisions.value = (data.revisions as DocumentRevision[]) || [];
    } catch {
      error.value = 'Failed to load document history';
    } finally {
      loading.value = false;
    }
  };

  const primaryRevision = computed(() => {
    return props.revision || (revisions.value.length > 0 ? revisions.value[0] : null);
  });

  const historyItems = computed(() =>
    buildDocumentHistoryView(revisions.value).map((rev) => ({
      revision: rev.revision,
      dateLabel: rev.effectiveDateLabel,
      changes: rev.changelogEntries.map((change) => change.description),
    }))
  );

  onMounted(() => {
    if (props.revision?.documentId) {
      getRevisions();
    }
  });
</script>

<template>
  <DocumentModal
    :title="title"
    :revision="primaryRevision"
    modal-title="Histórico das Atualizações (changelog)"
    document-info-title="HISTÓRICO DAS ATUALIZAÇÕES"
    document-number="RQ05.2"
    document-revision-label="REV.03"
    print-pill-label="Documento"
    @close="emit('close')"
  >
    <template #default>
      <HistoryRevisionList :items="historyItems" />
    </template>
  </DocumentModal>
</template>

<style scoped>
  @media print {
    .modal-header {
      display: none;
    }

    .print-button {
      display: none;
    }
  }
</style>
